<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="TableOfContents">
<div class="title-block">
<h1>Contents</h1>
</div>
<p class="toc1"><br/>
<span href="#/9781847676931_booktitlepage" title="Link target outside of Sample">Title Page</span><br/>
<span href="#/9781847676931_dedication" title="Link target outside of Sample">Dedication</span><br/>
<span href="#/9781847676931_epigraph" title="Link target outside of Sample">Epigraph</span><br/>
<a href="#/9781847676931_chapter_01">18th June 199…</a><br/>
<a href="#/9781847676931_part_01">Six Months Earlier …</a><br/>
<a href="#/9781847676931_chapter_02">9th December</a><br/>
<span href="#/9781847676931_chapter_03" title="Link target outside of Sample">10th December</span><br/>
<span href="#/9781847676931_chapter_04" title="Link target outside of Sample">11th December</span><br/>
<span href="#/9781847676931_part_02" title="Link target outside of Sample">Six Months Later …</span><br/>
<span href="#/9781847676931_chapter_05" title="Link target outside of Sample">18th June</span><br/>
<span href="#/9781847676931_chapter_06" title="Link target outside of Sample">19th June</span><br/>
<span href="#/9781847676931_part_03" title="Link target outside of Sample">Six Years Later …</span><br/>
<span href="#/9781847676931_acknowledgements" title="Link target outside of Sample">Acknowledgements</span><br/>
<span href="#/9781847676931_chapter_07" title="Link target outside of Sample">Also By Niccolò Ammaniti</span><br/>
<span href="#/9781847676931_abouttheauthor" title="Link target outside of Sample">About the Author</span><br/>
<span href="#/9781847676931_insertedcopyright" title="Link target outside of Sample">Copyright</span><br/>
</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847676931_toc.vue?b7111dce